export default {
  STRING: 'string',
  TEXT: 'text',
  NUMBER: 'number',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SELECT: 'select',
  TABLE: 'table',
  AUTOCOMPLETE: 'autocomplete',
  EAN: 'ean',
  SIGNATURE: 'signature',
  PHOTO: 'photo',
  CODE: 'code',
  DATE: 'date',
  TIME: 'time',
  MULTIPLE: 'multiple',
  PERMAMENT: 'permament',
  CONFIRMATION: 'confirmation',
  FORMULE: 'formule',
  ARCHIVE: 'archive',
  RELATED: 'related',
  DEPEND: 'depend',
  predefined: ['select','autocomplete', 'radio', 'checkbox','formule'],
  notUpdate: ["archive", "formule"],
  hidden: ["formule"]
}
